import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <nav
        style={{
          width: '220px',
          background: '#1e293b',
          color: '#e2e8f0',
          display: 'flex',
          flexDirection: 'column',
          padding: '1.5rem 0',
          flexShrink: 0,
        }}
      >
        <div style={{ padding: '0 1.25rem 1.5rem', fontWeight: 700, fontSize: '1.1rem', color: '#fff' }}>
          AutoDocument
        </div>

        <NavItem to="/" label="Dashboard" exact />
        <NavItem to="/templates" label="Templates" />
        <NavItem to="/documents" label="Documents" />
        {user?.role === 'admin' && <NavItem to="/users" label="Users" />}

        <div style={{ flexGrow: 1 }} />

        <NavItem to="/settings" label="Settings" />
        <NavItem to="/settings/tokens" label="API Tokens" />
        <NavItem to="/settings/oauth-sessions" label="OAuth Sessions" />
        <button
          onClick={handleLogout}
          style={{
            margin: '0 .75rem',
            padding: '.5rem .75rem',
            background: 'transparent',
            border: '1px solid #475569',
            borderRadius: '6px',
            color: '#94a3b8',
            fontSize: '.875rem',
            cursor: 'pointer',
            textAlign: 'left',
          }}
        >
          Sign out ({user?.username})
        </button>
      </nav>

      {/* Main */}
      <main style={{ flex: 1, padding: '2rem', overflowY: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
}

function NavItem({ to, label, exact }: { to: string; label: string; exact?: boolean }) {
  return (
    <NavLink
      to={to}
      end={exact}
      style={({ isActive }) => ({
        padding: '.5rem 1.25rem',
        color: isActive ? '#fff' : '#94a3b8',
        background: isActive ? '#334155' : 'transparent',
        fontWeight: isActive ? 600 : 400,
        fontSize: '.875rem',
        display: 'block',
        textDecoration: 'none',
        borderLeft: isActive ? '3px solid #3b82f6' : '3px solid transparent',
      })}
    >
      {label}
    </NavLink>
  );
}
